//vendors
import React, {ChangeEvent, useMemo, memo} from "react";
import classNames from "classnames";
import {Tooltip} from "@acc/tooltip";
import {VBox} from "@acc/layout";
//styles
import style from './simple_text_field.module.scss';

type Props = {
	type?: 'text' | 'password' | 'number',
	name?: string,
	disabled?: boolean,
	placeholder?: string,
	label?: string | JSX.Element,
	subLabel?: string,
	className?: string,
	horizontal?: boolean,
	value?: string | number,
	onChange: (value: string) => void,
	error?: string,
	onBlur?: () => void,
	touched?: boolean
	onKeyPress?: (e) => void,
	autoFocus?: boolean
	required?: boolean,
	fieldsProportions?: number[],
	tooltip?: string | JSX.Element
};

export const SimpleTextField = memo(({
	                                     type = 'text',
	                                     disabled = false,
	                                     horizontal = false,
	                                     touched = false,
	                                     autoFocus = false,
	                                     required = false,
	                                     value = '',
	                                     ...props
                                     }: Props) => {
	const handlerOnChange = (e: ChangeEvent<HTMLInputElement>) => {
		props.onChange(e.target.value);
	};
	
	const Label = useMemo(() => {
		const InnerLabel = (
			<VBox size="auto">
				<div>{required && <span>* </span>}{props.label}</div>
				{props.subLabel && <p className={style.subLabel}>{props.subLabel}</p>}
			</VBox>
		)
		
		if (!props.label) return null;
		
		return <>
			<label style={props.fieldsProportions ? {"flex": props.fieldsProportions[0]} : {}}>
				{props.tooltip
					? (
						<Tooltip
							message={<VBox className={style.tooltipMsg}>{props.tooltip}</VBox>}
							placement="top"
							trigger="hover"
							delayShow={1000}
						>
							{InnerLabel}
						</Tooltip>
					)
					: InnerLabel
				}
			</label>
		</>;
	}, [props.fieldsProportions, props.tooltip, props.label, required, props.subLabel]);
	
	return (
		<div className={classNames(
			style.inputWrap,
			props.className,
			{[style.horizontal]: horizontal, [style.errorInput]: !!props.error && touched}
		)}>
			{Label}
			<div className={style.input} style={props.fieldsProportions ? {"flex": props.fieldsProportions[1]} : {}}>
				<input
					id={props.name}
					type={type}
					disabled={disabled}
					placeholder={props.placeholder}
					onChange={handlerOnChange}
					onBlur={props.onBlur}
					value={value}
					onKeyPress={props.onKeyPress}
					autoFocus={autoFocus}
				/>
				
				{touched && props.error && <span className={style.error}>{props.error}</span>}
			</div>
		</div>
	)
})
